import {TechnicalSupport} from '@features/TechnicalSupport/TechnicalSupport';

const TechnicalSupportPage = () => {
    return <TechnicalSupport />;
};

export default TechnicalSupportPage;
